export default __webpack_public_path__ + "static/media/white-pricing-card.e5536435.jpg";